import { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import Lgpd from '../../Lgpd';
import PublicacoesCarrossel from '../../Filtros/PublicacoesCarrossel';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../InfoComponent';

class Publicacoes extends Component {

	render() {

		return (


			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>

				<InfoComponent image={"publicacoes"} page={'publicacoes'}></InfoComponent>
			
				{/* Content page */}
				<ErrorBoundary><PublicacoesCarrossel page={'publicacoes'} /></ErrorBoundary>

				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default Publicacoes;